import React from 'react';
import useSchemaStore from '../store/schemaStore';

const ErrorBanner = () => {
  const { lastError, clearError } = useSchemaStore();

  if (!lastError) return null;

  return (
    <div style={{ marginTop: 12 }}>
      <div className="alert alert-danger alert-dismissible fade show" role="alert">
        {lastError}
        <button type="button" className="btn-close" aria-label="Close" onClick={clearError}></button>
      </div>
    </div>
  );
};

export default ErrorBanner;
